import i18n from '@/i18n';

export default function errMessage(error, default_message = i18n.t('unknown_error')) {
    return typeof error == 'string'
        ? error
        : (error && error.response && error.response.data)
            ? (error.response.data.err_message || error.response.data.message || error.response.data.error?.message || default_message)
            : ((error && error.message) ? error.message : default_message)
}
